import { GET_DONE_AGENDA, AGENDA_LOADING } from '../actions/types';

const initialState = {
  done: [],
  loading: false,
};

export default function(state = initialState, action) {
  switch (action.type) {
    case GET_DONE_AGENDA:
      return {
        ...state,
        done: action.payload,
        loading: false,
      };
    case AGENDA_LOADING:
      return {
        ...state,
        loading: true,
      };
    default:
      return state;
  }
}
